import React from "react";

const Pass = ({
  width = 19,
  height = 19,
  stroke = "#2F6AF5",
  strokeWidth = 1.65,
  strokeLinecap = "round",
  strokeLinejoin = "round",
}) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="8" fill="#466BF6" fill-opacity="0.1" />
      <path
        d="M22.5812 25.418C22.3318 25.169 22.0345 24.9731 21.7074 24.8422L11.3587 20.6923C11.2352 20.6427 11.1297 20.5565 11.0566 20.4453C10.9834 20.334 10.946 20.2031 10.9494 20.07C10.9528 19.9369 10.9969 19.808 11.0756 19.7007C11.1544 19.5933 11.2641 19.5127 11.3901 19.4695L36.1851 10.987C36.3007 10.9452 36.4258 10.9372 36.5458 10.964C36.6658 10.9908 36.7757 11.0511 36.8626 11.1381C36.9496 11.225 37.0099 11.3349 37.0367 11.4549C37.0635 11.5749 37.0555 11.7 37.0137 11.8157L28.5312 36.6107C28.488 36.7366 28.4074 36.8463 28.3 36.9251C28.1927 37.0038 28.0638 37.0479 27.9307 37.0513C27.7976 37.0547 27.6667 37.0173 27.5554 36.9441C27.4442 36.871 27.358 36.7655 27.3084 36.642L23.1585 26.2907C23.027 25.9638 22.8306 25.6669 22.5812 25.418ZM22.5812 25.418L36.8584 11.1436"
        stroke="#466BF6"
        stroke-width="2.16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Pass;
